import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'oap-popin-alert',
  templateUrl: './popin-alert.component.html',
  styleUrls: ['./popin-alert.component.scss']
})
export class PopinAlertComponent implements OnInit {
    @Input() message = '';
    @Input() isOpen = false;

  constructor() { }

  ngOnInit() {
  }

}
